var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/master-stock.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-65859324!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/master-stock.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/MasterStock.vue
// module id = 658
// module chunks = 1